import React from 'react';
import { Link } from 'react-router-dom';
import Logo, { LogoLight } from '../../../components/Sidebar/Logo';
import { useTheme } from '../../../context/ThemeContext';
import './StaticFooter.scss';

const StaticFooter = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark' || theme === 'system';

  const handleHelpCenterClick = (e) => {
    e.preventDefault();
    if (window.$crisp) {
      window.$crisp.push(['do', 'chat:open']);
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              {isDark ? <Logo width="120px" /> : <LogoLight width="120px" />}
            </div>
            <p>The future of teamwork lives in Zoobbe. Streamline your workflow with powerful boards and seamless collaboration.</p>
          </div>
          <div className="footer-section">
            <h4>Product</h4>
            <ul>
              <li><a href="#features">Features</a></li>
              <li><a href="#pricing">Pricing</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/changelog">Changelog</Link></li>
              <li><Link to="/roadmap">Roadmap</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Support</h4>
            <ul>
              <li><a href="#" onClick={handleHelpCenterClick}>Help Center</a></li>
              <li><Link to="/feature-request">Feature Request</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/legal/terms-of-service">Terms of Service</Link></li>
              <li><Link to="/legal/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Zoobbe. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default StaticFooter;

